import React from 'react';
import { Instagram, Linkedin, Mail, MapPin, MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import Reveal from '../ui/Reveal';

const Footer = () => {
    return (
        <footer className="bg-slate-50 border-t border-slate-200 pt-16 pb-8">
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
                    {/* Brand */}
                    <div className="col-span-1 md:col-span-1">
                        <Reveal>
                            <div className="flex items-center gap-2 mb-4">
                                <picture>
                                    <source srcSet="/logo.webp" type="image/webp" />
                                    <img src="/logo.png" alt="Acodr Solutions" width="32" height="32" className="h-8 w-auto object-contain" />
                                </picture>
                                <span className="text-2xl font-bold text-slate-900">Acodr<span className="text-primary">.</span></span>
                            </div>
                            <p className="text-slate-600 mb-6">
                                Your Budget-Smart Product Engineering Partner.
                            </p>
                            <div className="flex space-x-4">
                                <a href="https://www.instagram.com/acodrsolutions/" target="_blank" rel="noopener noreferrer" className="text-slate-600 hover:text-primary transition-colors" aria-label="Visit our Instagram page"><Instagram size={20} /></a>
                                <a href="https://www.linkedin.com/in/acodr-solutions-2472783b4/" target="_blank" rel="noopener noreferrer" className="text-slate-600 hover:text-primary transition-colors" aria-label="Visit our LinkedIn page"><Linkedin size={20} /></a>
                            </div>
                        </Reveal>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <Reveal delay={0.1}>
                            <h3 className="text-slate-900 font-semibold mb-4">Company</h3>
                            <ul className="space-y-2">
                                <li><Link to="/about" className="text-slate-600 hover:text-primary transition-colors">About</Link></li>
                                <li><Link to="/services" className="text-slate-600 hover:text-primary transition-colors">Services</Link></li>
                                <li><Link to="/portfolio" className="text-slate-600 hover:text-primary transition-colors">Portfolio</Link></li>
                                <li><Link to="/contact" className="text-slate-600 hover:text-primary transition-colors">Contact</Link></li>
                            </ul>
                        </Reveal>
                    </div>

                    {/* Services */}
                    <div>
                        <Reveal delay={0.2}>
                            <h3 className="text-slate-900 font-semibold mb-4">Services</h3>
                            <ul className="space-y-2">
                                <li><Link to="/services" className="text-slate-600 hover:text-primary transition-colors">Web Development</Link></li>
                                <li><Link to="/services" className="text-slate-600 hover:text-primary transition-colors">App Development</Link></li>
                                <li><Link to="/services" className="text-slate-600 hover:text-primary transition-colors">AI & Automation</Link></li>
                            </ul>
                        </Reveal>
                    </div>

                    {/* Contact */}
                    <div>
                        <Reveal delay={0.3}>
                            <h3 className="text-slate-900 font-semibold mb-4">Contact</h3>
                            <ul className="space-y-2">
                                <li className="flex items-center text-slate-600">
                                    <Mail size={16} className="mr-2" /> admin@acodr.co.uk
                                </li>
                                <li className="flex items-center text-slate-600">
                                    <MessageCircle size={16} className="mr-2" /> +91 90582 10133
                                </li>
                                <li className="flex items-start text-slate-600">
                                    <MapPin size={16} className="mr-2 mt-1 shrink-0" />
                                    <span>Chandigarh, India</span>
                                </li>
                            </ul>
                        </Reveal>
                    </div>
                </div>

                <div className="border-t border-slate-200 pt-8 flex flex-col md:flex-row justify-between items-center">
                    <p className="text-slate-500 text-sm">
                        © {new Date().getFullYear()} Acodr Solutions. All rights reserved.
                    </p>
                    <div className="flex space-x-6 mt-4 md:mt-0">
                        <a href="#" className="text-slate-500 hover:text-slate-900 text-sm">Privacy Policy</a>
                        <a href="#" className="text-slate-500 hover:text-slate-900 text-sm">Terms of Service</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
